import {Card, FormControl} from 'platform/components';
import {VStack} from 'platform/foundation';

import {GetInvoiceV4ApiResponse} from '@dms/api/core';
import {testIds} from '@dms/routes';

import {CancellingInvoiceDetail} from '../../components/CancellingInvoiceDetail';
import {CustomerAndSupplierDetail} from '../../components/CustomerAndSupplierDetail';
import {ListOfItemsDetail} from '../../components/ListOfItemsDetail';
import {PaymentDatesDetail} from '../../components/PaymentDatesDetail';
import {PaymentDetailsDetail} from '../../components/PaymentDetailsDetail';
import {PaymentsNotesDetail} from '../../components/PaymentsNotesDetail';
import {AccountingDocumentFormValues} from '../../types';

interface InvoiceDetailsProps {
  control: FormControl<AccountingDocumentFormValues>;
  invoice: GetInvoiceV4ApiResponse;
}

export function InvoiceDetails(props: InvoiceDetailsProps) {
  return (
    <VStack spacing={4}>
      <Card>
        <VStack spacing={4}>
          <CustomerAndSupplierDetail
            customer={props.invoice.customer}
            supplier={props.invoice.supplier}
            additionalCustomer={props.invoice.additionalCustomer}
            additionalFields={props.invoice.customFields}
            data-testid={testIds.accounting.invoiceDetail('customerAndSupplier')}
          />
          <PaymentDatesDetail
            control={props.control}
            data-testid={testIds.accounting.invoiceDetail('paymentDates')}
          />
        </VStack>
      </Card>

      <CancellingInvoiceDetail
        cancelingInvoiceType="ISSUED"
        cancelingInvoiceId={props.invoice.cancelledDocumentId}
      />

      <PaymentDetailsDetail
        control={props.control}
        data-testid={testIds.accounting.invoiceDetail('payment-details')}
      />

      <ListOfItemsDetail
        items={props.invoice.items}
        summary={props.invoice.documentSummary}
        exchangeRateRatioCalculation={props.invoice.exchangeRateRatioDocumentSummary}
        control={props.control}
        data-testid={testIds.accounting.invoiceDetail('listOfItems')}
      />

      <PaymentsNotesDetail control={props.control} />
    </VStack>
  );
}
